import { saleIdLabel } from '@entities/sale'
import { saleIdHint } from './sales.css'

export function SaleIdHint({ saleId }: { saleId: string }) {
  return (
    <span className={saleIdHint} title={saleId}>
      {saleIdLabel(saleId)}
    </span>
  )
}
